import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/login/bg.png'
import _imports_2 from '@/assets/login/wechat.png'
import _imports_3 from '../assets/common/tolefticon.png'
import _imports_4 from '../assets/attendance/empty.png'
import _imports_5 from '../assets/common/companyicon.png'
import _imports_6 from '../assets/common/success.png'
import _imports_7 from '../assets/common/err.png'
import _imports_8 from '../assets/common/torighticon.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "login" }
const _hoisted_4 = { class: "login-pass" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "memory point" }
const _hoisted_7 = { class: "other-login-type" }
const _hoisted_8 = {
  key: 0,
  class: "wx-login login"
}
const _hoisted_9 = {
  key: 1,
  class: "chooseCompany"
}
const _hoisted_10 = {
  key: 0,
  class: "chooseCompany-title"
}
const _hoisted_11 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","align-items":"center","flex-wrap":"wrap"}
}
const _hoisted_12 = { class: "company-list-box" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex gap-10 flex-ai-c" }
const _hoisted_15 = { class: "text-14" }
const _hoisted_16 = { class: "flex flex-ai-c gap-10" }
const _hoisted_17 = {
  key: 0,
  class: "tagstatus1"
}
const _hoisted_18 = {
  key: 1,
  class: "tagstatus2"
}
const _hoisted_19 = { class: "companysupname" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "left" }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "left-logo"
      }),
      _createElementVNode("img", {
        src: _imports_1,
        alt: "",
        class: "left-bg"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("h1", null, "登录", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            placeholder: "请输入用户名",
            class: "login-input",
            type: "text",
            modelValue: _ctx.userName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            placeholder: "请输入密码",
            class: "login-input",
            type: "password",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            onKeydown: _withKeys(_ctx.login, ["enter"])
          }, null, 8, ["modelValue", "onKeydown"]),
          _createVNode(_component_el_input, {
            placeholder: "请输入验证码",
            class: "login-input",
            type: "number",
            modelValue: _ctx.verityCode,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.verityCode) = $event)),
            onKeydown: _withKeys(_ctx.login, ["enter"])
          }, {
            suffix: _withCtx(() => [
              _createElementVNode("img", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCode())),
                class: "verity-img point",
                src: _ctx.verityImg,
                alt: ""
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          }, 8, ["modelValue", "onKeydown"]),
          _createVNode(_component_el_button, {
            class: "btn",
            type: "primary",
            onClick: _ctx.login,
            round: ""
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("下一步")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.isStorage,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isStorage) = $event))
            }, null, 8, ["modelValue"]),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "记住密码", -1))
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "other-login-title" }, " 第三方登录 ", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "other-icon point",
              src: _imports_2,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.qrLogin()))
            })
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.isQr && !_ctx.showcompany]
      ]),
      (_ctx.isQr && !_ctx.showcompany)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", {
              class: "close point",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancelQr()))
            }, "×"),
            _cache[12] || (_cache[12] = _createElementVNode("iframe", {
              sandbox: "allow-top-navigation allow-scripts allow-same-origin",
              src: "https://open.weixin.qq.com/connect/qrconnect?appid=wx84466f4f797cb991&scope=snsapi_login&redirect_uri=https%3A%2F%2Fweb.51zidan.com%2F%23%2Flogin%3FisNext%3Dtrue&state=saas"
            }, null, -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.showcompany)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "backbox",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("img", {
                class: "tolefticon",
                src: _imports_3,
                alt: ""
              }, null, -1),
              _createTextVNode(" 返回 ")
            ])),
            (_ctx.companyList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "选择你管理的企业"))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[14] || (_cache[14] = [
                  _createElementVNode("img", {
                    src: _imports_4,
                    style: {"width":"80%"}
                  }, null, -1),
                  _createElementVNode("div", { style: {"margin-top":"30px","color":"rgb(132 132 132)","font-size":"18px"} }, "该微信暂无添加企业", -1)
                ]))),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyList, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "itembox",
                  key: i,
                  onClick: ($event: any) => (_ctx.sureLogin(item.companyId, item.phone))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[17] || (_cache[17] = _createElementVNode("img", {
                      src: _imports_5,
                      class: "w-h-32",
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.companyName), 1),
                      _createElementVNode("div", _hoisted_16, [
                        (item.auditStatus)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[15] || (_cache[15] = [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "w-h-12",
                                alt: ""
                              }, null, -1),
                              _createTextVNode("已认证 ")
                            ])))
                          : _createCommentVNode("", true),
                        (!item.auditStatus)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[16] || (_cache[16] = [
                              _createElementVNode("img", {
                                src: _imports_7,
                                class: "w-h-12",
                                alt: ""
                              }, null, -1),
                              _createTextVNode("未认证 ")
                            ])))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_19, "主管理员：" + _toDisplayString(item.superAdminName), 1)
                      ])
                    ])
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("img", {
                    src: _imports_8,
                    class: "w-h-16",
                    alt: ""
                  }, null, -1))
                ], 8, _hoisted_13))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}